import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import updateCoach from "./component/updateCoach.vue";
import updateScore from "./component/updateScore.vue";
import { loadMoreList, commonData } from "@/mixins/index";
export default {
  name: "coachmanage",
  mixins: [loadMoreList, commonData],
  components: {
    updateCoach: updateCoach,
    updateScore: updateScore
  },
  data: function data() {
    return {
      paramsData: {
        id: '',
        round_name: ''
      },
      tableData: [],
      total: 0,
      formatMap: {
        "league": '联赛制',
        "knockout": '淘汰制',
        "group+knockout": '小组赛+淘汰赛'
      },
      tournamentMap: {
        "official": '正式赛事',
        "friendly": '友谊赛',
        "youth": '青少年赛事'
      },
      roundsList: []
    };
  },
  created: function created() {
    console.log("this.$route.query", this.$route.query);
    this.paramsData.id = this.$route.query.coachId || sessionStorage.getItem('coachId');
    this.getList();
    this.getroundsList();
  },
  methods: {
    getroundsList: function getroundsList() {
      var _this = this;

      this.$api.rounds({
        id: this.paramsData.id
      }).then(function (res) {
        if (res.code == 200) {
          _this.roundsList = res.data;
        }
      });
    },
    getList: function getList() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this2.paramsData.page = page;

                _this2.$api.schedule(_objectSpread({}, _this2.paramsData)).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    data.forEach(function (item) {
                      item.location = item.venue ? item.venue.location : '/';
                      item.winnerName = item.winner ? item.winner.name : '/';
                      item.match_phase = item.extra_info ? item.extra_info.match_phase : '';
                    });
                    _this2.tableData = data;
                    _this2.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleCancle: function handleCancle(id) {
      this.$refs.addCancle.init(id);
    },
    handleManageInfo: function handleManageInfo(id) {
      this.$refs.addManage.init(id);
    },
    //关闭报名
    closeGenerate: function closeGenerate(id) {
      var _this3 = this;

      this.$confirm("此操作将关闭报名, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$api.closeAndGenerate({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.$message.success("关闭报名成功!");

                    _this3.getList(_this3.paramsData.page);
                  } else {
                    _this3.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    handleMange: function handleMange(id) {
      sessionStorage.setItem('coachId', id + '');
      this.$router.push({
        path: "/eventmanagement/coachmanage",
        query: {
          coachId: id
        }
      });
    }
  }
};